import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { CommonModule } from '@angular/common';
import { LogoutButtonComponent } from './logout-button/logout-button.component';
import { LogoutComponent } from './logout/logout.component';

@NgModule({
  declarations: [LoginComponent, LogoutButtonComponent, LogoutComponent],
  imports: [CommonModule, ReactiveFormsModule],
  exports: [LogoutButtonComponent, LogoutComponent],
})
export class AuthModule {}
